import { APP_INITIALIZER, NgModule, Optional, SkipSelf } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { RouteReuseStrategy, RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

import { RouteReusableStrategy } from './route-reusable-strategy';
import { ApiPrefixInterceptor } from './http/api-prefix.interceptor';
import { ErrorHandlerInterceptor } from './http/error-handler.interceptor';
//import { Branding } from './brand.service';
import { AppInitService } from './app-init.service';
import { Api, BASE_URL_SERVER, SECURITY_API, BUSINESS_API } from './api.service';
import { HttpClient } from '@angular/common/http';
import { environment } from '@env/environment';

// const SECURITY_CONTEXT_ROOT_URI = new InjectionToken('_securityContextRootUri');
// const BUSINESS_CONTEXT_ROOT_URI = new InjectionToken('_restContextRootUri');
const apiConfig = environment.serverUrl;

// export function initializeApp(appInitService: AppInitService) {
//   return (): Promise<any> => appInitService.init();
// }

export function apiFactory(http: HttpClient, baseUrl: any, contextUri = '') {
  return new Api(http, `${baseUrl}${contextUri}`);
}

// export function brandingFactory() {
//   return new Branding(
//     {
//       default: {
//         code: 'TO',
//         aliases: ['', undefined],
//         props: environment.brands.default,
//       },
//       brand1: { code: 'BR1', props: environment.brands.brand1 },
//       brand2: { code: 'BR2', props: environment.brands.brand2 },
//     },
//     'default'
//   );
// }

@NgModule({
  imports: [CommonModule, HttpClientModule, TranslateModule, RouterModule],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ApiPrefixInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ErrorHandlerInterceptor,
      multi: true,
    },
    {
      provide: RouteReuseStrategy,
      useClass: RouteReusableStrategy,
    },
    AppInitService,
    // {
    //   provide: Branding,
    //   useFactory: brandingFactory,
    // },
    // {
    //   provide: APP_INITIALIZER,
    //   useFactory: initializeApp,
    //   deps: [AppInitService],
    //   multi: true,
    // },
    { provide: BASE_URL_SERVER, useValue: apiConfig },
    { provide: Api, useFactory: apiFactory, deps: [HttpClient, BASE_URL_SERVER] },
    // { provide: SECURITY_API, useFactory: apiFactory, deps: [HttpClient, BASE_URL_SERVER, SECURITY_CONTEXT_ROOT_URI] },
    // { provide: BUSINESS_API, useFactory: apiFactory, deps: [HttpClient, BASE_URL_SERVER, BUSINESS_CONTEXT_ROOT_URI] }
  ],
})
export class CoreModule {
  constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
    // Import guard
    if (parentModule) {
      throw new Error(`${parentModule} has already been loaded. Import Core module in the AppModule only.`);
    }
  }
}

export { Api };
